export default "__VITE_ASSET__CYVOgpDb__"